import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isChallengesLongText(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.CHALLENGES_LONG_TEXT && typeof label === 'string' && typeof value === 'string';
}
function _formatChallengesLongText(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return undefined;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatChallengesLongText(submission) {
  if (isChallengesLongText(submission)) {
    return _formatChallengesLongText(submission);
  }
  return undefined;
}
//# sourceMappingURL=challenges-long-text-preview.js.map